import React, { useState } from "react";
import { Box, Form, TextInput, FormField, Button, Text } from "grommet";
import AuthService from "../../services/auth.service";
import { presentToastErrorContent, presentToastError } from "@shared/Toast";
import { useTranslation } from "react-i18next";

// import PropTypes from 'prop-types';

export default function ForgotComponent(props) {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const onEmailChange = (event) => setEmail(event.target.value);

  const handleSend = (e) => {
    AuthService.forgot(email).then(
      () => {
        setSent(true);
      },
      (error) => {
        if (error.response.status === 404)
          presentToastError(t("forgot.emailNotFound"));
        else presentToastErrorContent(error);
      }
    );
  };

  return sent ? (
    <Box gap="medium">
      <Text weight="bold">{t("forgot.sentTitle")}</Text>
      <Text>{t("forgot.sentInstructions")}</Text>
    </Box>
  ) : (
    <Form {...props} onSubmit={handleSend}>
      <Box gap="medium">
        <FormField label={t("forgot.email")} htmlFor="username">
          <TextInput
            id="username"
            placeholder={t("forgot.emailPlaceholder")}
            onChange={onEmailChange}
          />
        </FormField>
        <Button label={t("forgot.send")} primary type="submit" alignSelf="center" />
      </Box>
    </Form>
  );
}

ForgotComponent.propTypes = {};
ForgotComponent.defaultProps = {};
